import { GoMarkGithub, GoProject } from "react-icons/go";
import { AiFillLinkedin } from "react-icons/ai";
import ListGroup from "react-bootstrap/ListGroup";
import styled from "styled-components";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import pdfFile from "./Resume/Resume.pdf";

export const IconList = () => {

	const openResume = () => {
		window.open(pdfFile, "_blank", "fullscreen=yes");
		return false;
	};
	
	return (
		<Wrapper className="mt-5">
			<a
				href="https://github.com/Ali7109"
				rel="noreferrer"
				target="_blank"
			>
				{" "}
				<OverlayTrigger
					placement="top"
					overlay={<Tooltip id={"tooltip-top"}>Github</Tooltip>}
				>
					<ListGroup.Item>
						<GoMarkGithub className="web-icon" />
					</ListGroup.Item>
				</OverlayTrigger>
			</a>
			<OverlayTrigger
				placement="top"
				overlay={<Tooltip id={"tooltip-top"}>Resume / CV</Tooltip>}
			>
				<ListGroup.Item onClick={openResume}>
					<GoProject className="web-icon" />
				</ListGroup.Item>
			</OverlayTrigger>

			<a
				href="https://www.linkedin.com/in/ali-hassan-amin/"
				rel="noreferrer"
				target="_blank"
			>
				<OverlayTrigger
					placement="top"
					overlay={<Tooltip id={"tooltip-top"}>Linkedin</Tooltip>}
				>
					<ListGroup.Item>
						<AiFillLinkedin className="web-icon" />
					</ListGroup.Item>
				</OverlayTrigger>
			</a>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	display: flex;
	justify-content: space-around;
`;
